import Vue from 'vue'

window.Cookie = require('js-cookie');
window.Velocity = require('velocity-animate');
window.Vue = Vue

require('waypoints/lib/noframework.waypoints.min.js');

require('./templates/chart.js');

/*=============================
=      Check Window Width     =
=============================*/

window.checkWidth = function checkWidth(width) {
    return window.innerWidth < width;
};

/*=============================
=          Initialize         =
=============================*/

window.body = document.body;
window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;
window.header = document.getElementById('header');
window.headerHeight = header.offsetHeight;
window.headerHeightSticky = checkWidth(1200) ? (headerHeight - topbarHeight) : (checkWidth(1920) ? Math.floor((window.innerWidth * (.039063 + .045313)) * 100) / 100 : 162);

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/*=============================
=       Lazyload Scripts      =
=============================*/

window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
    var scriptWaypoint = new Waypoint({
        element: el,
        handler: function(direction) {
            addJS(src);

            this.destroy();
        },
        offset: offset
    });
};

window.addJS = function addJS(src) {
    var script = document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');

    document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
    Velocity(scrollTo, 'scroll', {duration: 800, offset: -(headerHeightSticky + 50)});
};

/*=============================
=       Get URL Parameter     =
=============================*/

window.getParameter = function getParameter(obj, parameter) {
    var value = '';

    obj.href.split('&').forEach(function(param) {
        if(param.indexOf(parameter) > -1)
            value = param.split(parameter+'=')[1].split('#')[0];
    });

    return value;
};

/*=============================
=      Google Tag Manager     =
=============================*/

// window.addEventListener('load', function() {
//     var gtm = process.env.GTM_ID;

//     if(gtm) {
//         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
//         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
//         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
//         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
//         })(window,document,'script','dataLayer', gtm);

//         var noscript = document.createElement('noscript');

//         noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id='+gtm+'" height="0" width="0" style="display:none;visibility:hidden"></iframe>';

//         document.body.appendChild(noscript);
//     }
// });


window.convertToValidJSON = function convertToValidJSON(input) {
    // Replace parentheses with appropriate brackets and fix quotes
    const fixedInput = input
        .replace(/\(/g, "{") // Replace opening parentheses with curly braces
        .replace(/\)/g, "}") // Replace closing parentheses with curly braces
        .replace(/'/g, '"') // Replace single quotes with double quotes
        .replace(/([a-zA-Z0-9_]+):/g, '"$1":') // Add quotes around keys

        // Fix arrays enclosed in quotes to proper JSON arrays
        .replace(/"\[([^\]]*)\]"/g, "[$1]");

    // Parse the corrected string into a JSON object
    return JSON.parse(fixedInput);
}
